import { useContext } from 'react';
import { cognitoUserManager } from '@/configs/cognitoAuthConfig';
import { AuthContext } from '@/providers/authContext';
import { type AuthContextType } from '@/types';

export const useAuth = (): AuthContextType<typeof cognitoUserManager> => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }

  return context;
};
